export interface LanguageOption {
  code: string;
  flag: string;
  label: string;
}

export const LANGUAGES: LanguageOption[] = [
  {
    code: "en",
    flag: "🇬🇧",
    label: "English",
  },
  {
    code: "tr",
    flag: "🇹🇷",
    label: "Türkçe",
  },
];

export const DEFAULT_LANGUAGE = "en";

